import { useEffect, useState } from 'react'
import HttpService from '../services/HttpService'
import UserService from '../services/UserService'
import ConfigAccess from './ConfigAccess'
import { Badge, Button, Card, Page } from './ui'

export default function Profile(props) {
    const profile = UserService.getProfile()
    const [empresa, setEmpresa] = useState(null)

    useEffect(() => {
        props.handleTitulo('Mi perfil')
        HttpService.getAxiosClient().get('/empresa').then((res) => setEmpresa(res.data))
    }, [])

    const codigoEmpresa = empresa?.codigoEmpresa || profile.company || ''
    const nombreEmpresa = empresa?.nombre || ''

    return (
        <Page
            description="Datos de tu sesión en el panel. El acceso se gestiona con Amazon Cognito."
            actions={
                <Button
                    variant="secondary"
                    onClick={() => {
                        window.history.replaceState('', '', '/')
                        UserService.doLogout()
                    }}
                >
                    Cerrar sesión
                </Button>
            }
        >
            <div className="grid gap-6 lg:grid-cols-3">
                <Card className="p-6 lg:col-span-1">
                    <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-brand-600 text-xl font-semibold text-white">
                        {(
                            (profile.givenName?.[0] || '') + (profile.familyName?.[0] || '')
                            || String(profile.email || 'U').slice(0, 2)
                        ).toUpperCase()}
                    </div>
                    <h3 className="mt-4 text-lg font-semibold text-slate-900">{profile.displayName || profile.email || '—'}</h3>
                    {codigoEmpresa && <p className="mt-1 font-mono text-sm text-slate-500">{codigoEmpresa}</p>}
                    {nombreEmpresa && <p className="mt-0.5 text-sm text-slate-500">{nombreEmpresa}</p>}
                    <p className="mt-1 text-sm text-slate-400">{profile.email}</p>
                    <div className="mt-4 flex flex-wrap gap-2">
                        {(profile.groups.length ? profile.groups : ['sin grupo']).map((g) => (
                            <Badge key={g} tone={g === 'admin' ? 'success' : 'neutral'}>{g}</Badge>
                        ))}
                    </div>
                </Card>
                <Card className="p-6 lg:col-span-2">
                    <h3 className="text-sm font-semibold text-slate-900">Detalles de la cuenta</h3>
                    <dl className="mt-4 divide-y divide-slate-100">
                        {[
                            ['Nombre', profile.givenName || '—'],
                            ['Apellidos', profile.familyName || '—'],
                            ['Correo', profile.email || '—'],
                            ['Usuario Cognito', profile.username || '—'],
                            ['Código de empresa', codigoEmpresa || '—'],
                            ['Empresa', nombreEmpresa || '—'],
                            ['Roles', profile.groups.join(', ') || '—'],
                        ].map(([label, value]) => (
                            <div key={label} className="grid grid-cols-3 gap-4 py-3 text-sm">
                                <dt className="text-slate-500">{label}</dt>
                                <dd className="col-span-2 font-medium text-slate-900 break-all">{value}</dd>
                            </div>
                        ))}
                    </dl>
                    <div className="mt-6 flex gap-3">
                        <ConfigAccess className="inline-flex items-center justify-center rounded-xl bg-brand-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-brand-700">
                            Ir a configuración
                        </ConfigAccess>
                    </div>
                </Card>
            </div>
        </Page>
    )
}
